import React, { Component } from 'react'

export default class QuizRating extends Component {
    constructor(props) {
        super(props)
        this.state = {
            stars: [],
            rating: props.value || 0,
            hovered: 0,
            selectedIcon: "★",
            deselectedIcon: "☆"
        }
        
        this.props = props

        let outOf = props.outOf ? props.outOf : 5

        for (var i = 0; i < outOf; i++) {
            this.state.stars.push(i + 1)
        }
    }

    changeRating(newRating) {
        this.setState({
            rating: newRating
        })

        if (this.props.onChange){
            this.props.onChange(newRating)
        }
    }

    hoverRating(rating) {
        this.setState({
            hovered: rating
        })
    }

    render() {

        const { stars, rating, hovered, deselectedIcon, selectedIcon } = this.state

        return (
            <div className={"wf-tactic-quiz-form-field-rating wf-tactic-quiz-form-rating wf-tactic-quiz-rating wf-tactic-rating wf-rating rating"}>
                {stars.map(star => {
                    return (
                        <span
                            type="Rating"
                            key= {star}
                            name= {this.props.field.name}
                            className={
                                "wf-tactic-quiz-form-field-rating-starImg wf-tactic-quiz-form-field-starImg wf-tactic-quiz-form-starImg wf-tactic-quiz-starImg wf-tactic-starImg wf-starImg " + 
                                (rating < star ? (hovered < star ? "wf-notSelected" : "wf-selected") : "wf-selected")
                            }
                            style={{ cursor: 'pointer' }}
                            onClick={() => { this.changeRating(star) }}
                            onMouseEnter={() => { this.hoverRating(star) }}
                            onMouseLeave={() => { this.hoverRating(0) }}
                        >
                            {rating < star ?
                                hovered < star ? deselectedIcon : selectedIcon
                                :
                                selectedIcon
                            }
                        </span>
                    )
                })}
            </div>
        )
    }
}